import { action } from 'satcheljs';
import ItemId from 'owa-service/lib/contract/ItemId';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';

const onSmimeItemDecodeFailed = action(
    'onSmimeItemDecodeFailed',
    (itemId: ItemId, errorState: SmimeErrorStateEnum) => ({ itemId, errorState })
);

export default onSmimeItemDecodeFailed;
